export default "__VITE_ASSET__eFeVcwfL__"